import React from 'react';
import PropTypes from 'prop-types';
import attributesOptions from 'js/modules/attributes';
import RoomIcon from './RoomIcon';
import RoomIconToolTip from './RoomIconToolTip';

const internals = {
  orientation: {
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal',
  },
};

const RoomIcons = ({attributes, withOutName, roomName, className, orientation}) => {

  const icons = attributes.map((icon, index) => {

    const options = attributesOptions[icon.id];

    const tooltipContent = <RoomIconToolTip options={options} />;

    if (index > 12) {
      console.warn(
        'Warning: Only 13 room features are ' +
        `aloud. ${icon.id} is hidden.`
      );

      return null;
    }

    return (
      <RoomIcon
        key={`rm-icon-${roomName}-${icon.id}`}
        name={icon.name}
        options={options}
        roomName={roomName}
        tooltipContent={tooltipContent}
        withOutName={withOutName}
        orientation={orientation} />
    );

  });

  return (
    <ul className={`rct-icns ${className}`}>
      {icons}
    </ul>
  );

};

RoomIcons.propTypes = {
  className: PropTypes.string,
  attributes: PropTypes.array.isRequired,
  roomName: PropTypes.string.isRequired,
  withOutName: PropTypes.bool,
  orientation: PropTypes.string,
};

RoomIcons.defaultProps = {
  className: '',
  attributes: [],
  roomName: '',
  withOutName: false,
  orientation: internals.orientation.HORIZONTAL,
};

export default RoomIcons;



// WEBPACK FOOTER //
// ./js/components/step2/room-icons/RoomIcons.js